import { AutogenLayoutManageRecurringPayAdjustments } from "./autogen/AutogenLayoutManageRecurringPayAdjustments";
import { ChangeEvent, ClickEvent, TableRowDisplayEvent, Textbox, Toast } from "@mcleod/components";
import { Api, DisplayType, DisplayValue } from "@mcleod/core";

export interface ManageRecurringPayAdjustmentProps {
    date: Date;
    currency_code: string;
    payee_type?: string;
    payee_status: string;
    payees: string;
    payees_exclude: boolean;
    departments?: string;
    departments_exclude?: boolean;
    frozen_payables: string;
    payment_method: string;
    payment_recipient?: string;
    bonus_code?: string;
    bonus_tax_method?: string;
    override_frequency?: string;
    is_driver_settlement?: boolean;
    is_office?: boolean;
    showDisabledTooltip?: boolean;
}

export class ManageRecurringPayAdjustments extends AutogenLayoutManageRecurringPayAdjustments {
    private _props: ManageRecurringPayAdjustmentProps;

    onLoad(): void | Promise<void> {
        this.textboxDate.addChangeListener((event: ChangeEvent) => {
            this.buttonGeneratePayAdjustments.enabled = false;
            if (this._props.showDisabledTooltip ?? true) {
                this.buttonGeneratePayAdjustments.disabledTooltip = "Date has been changed. Please click Search to refresh the data.";
            } else {
                this.buttonGeneratePayAdjustments.removeTooltip();
            }
        });
        this.tableManageRecurring.addRowDisplayListener((event: TableRowDisplayEvent) => {
            const tableRow = event.getTableRow();
            const modelRow = tableRow.data;
            const amount = modelRow.getCurrency("amount");
            amount.setCurrencyCode(this.props.currency_code);
            modelRow.set("amount", amount);
            if (this.props.is_office) {
                const textboxPayeeId = tableRow.findComponentById("textboxPayeeId") as Textbox;
                if (textboxPayeeId) {
                    textboxPayeeId.quickInfoLayout = "lme/settlement/officepayroll/OfficePayeeQuickInfo";
                }
            }
        });
    }

    buttonSearchOnClick(event: ClickEvent) {
        if (this.panelSearchContainer.validateSimple()) {
            this.buttonSearch.busy = true;
            this.props.date = this.textboxDate.getDataValue();
            this.sourceManageRecurringPayAdjustments.search(this.props).finally(() => {
                this.buttonSearch.busy = false;
                if (this.sourceManageRecurringPayAdjustments.data.length > 0) {
                    this.buttonGeneratePayAdjustments.enabled = true;
                }
            });
        }
    }

    buttonGeneratePayAdjustmentsOnClick(event: ClickEvent) {
        this.buttonGeneratePayAdjustments.busy = true;
        Api.update(this.sourceManageRecurringPayAdjustments.url, this.props).then(() => {
            this.slideOut().then(() => {
                Toast.showSuccessToast("Pay adjustments were generated successfully");
            });
        }).finally(() => {
            this.buttonGeneratePayAdjustments.busy = false
        });
    }

    get props(): ManageRecurringPayAdjustmentProps {
        return this._props;
    }

    set props(value: ManageRecurringPayAdjustmentProps) {
        this._props = value;
        if (value?.date) {
            this.textboxDate.text = DisplayValue.getDateDisplayValue(value.date, DisplayType.DATE);
        }
    }
}
